export const CREATE_CREDIT_NOTE_BILL_BASE  = 'CREATE_CREDIT_NOTE_BILL_BASE';
export const GET_CREDIT_NOTE_BILL_BASES  = 'GET_CREDIT_NOTE_BILL_BASES';
export const CREDIT_NOTE_BILL_BASE_REQUEST  = 'CREDIT_NOTE_BILL_BASE_REQUEST';
export const DELETE_CREDIT_NOTE_BILL_BASE  = 'DELETE_CREDIT_NOTE_BILL_BASE';
export const UPDATE_CREDIT_NOTE_BILL_BASE  = 'UPDATE_CREDIT_NOTE_BILL_BASE';
export const CREDIT_NOTE_BILL_BASE_REQUEST_SUCCESS  = 'CREDIT_NOTE_BILL_BASE_REQUEST_SUCCESS';
export const CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE  = 'CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE';
export const GET_CREDIT_NOTE_BILL_BASES_PAGE  = 'GET_CREDIT_NOTE_BILL_BASES_PAGE';